function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Capa 1"
}, React.createElement("circle", {
  cx: 74.41,
  cy: 74.41,
  r: 71.41,
  fill: "none",
  stroke: "#03a9f4",
  strokeMiterlimit: 10,
  strokeWidth: 6
}), React.createElement("path", {
  d: "M116.26 48.46a35.77 35.77 0 0 1-9.89 2.71 17.06 17.06 0 0 0 7.55-9.48A34.29 34.29 0 0 1 103 45.84a17.16 17.16 0 0 0-29.64 11.73 17.67 17.67 0 0 0 .4 3.91 48.56 48.56 0 0 1-35.37-17.94 17.16 17.16 0 0 0 5.27 22.93 16.94 16.94 0 0 1-7.75-2.11v.19A17.24 17.24 0 0 0 49.66 81.4a17.12 17.12 0 0 1-4.5.56 15.17 15.17 0 0 1-3.25-.29 17.32 17.32 0 0 0 16 12 34.48 34.48 0 0 1-21.27 7.32 32.14 32.14 0 0 1-4.11-.24 48.3 48.3 0 0 0 26.32 7.7c31.57 0 48.83-26.15 48.83-48.82 0-.76 0-1.49-.06-2.22a34.23 34.23 0 0 0 8.64-8.95z",
  fill: "#03a9f4"
})));

var SvgTwitterIconHighlighted = function SvgTwitterIconHighlighted(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 148.82 148.82",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitterIconHighlighted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TwitterIconHighlighted.c4103a57.svg";
export { ForwardRef as ReactComponent };